module.exports = __webpack_public_path__ + "static/bg-952c4376a98f465c9b49503de28a57fa.jpg";